<!-- 
<div class="container" theme [styleObj]='brandStyleTheme'>

  <div class="row">

    <div class="col-12 col-md-4 msg-container">

      <div class="card">

        <div class="card-header">

          <ng-template headerSection></ng-template>

        </div>

        <div class="card-body">
 -->
        <div class="container">

          <div class="row justify-content-center">
            <div class="col-12 col-lg-6">          

              <div class="alert text-center" role="alert" [ngClass]="{
                            'alert-primary': isPrimaryMessageShown,
                            'alert-secondary': isSecondaryMessageShown,
                            'alert-success': isSuccessMessageShown,
                            'alert-danger': isDangerMessageShown,
                            'alert-warning': isWarningMessageShown,
                            'alert-info': isInfoMessageShown
                          }" 
                >
                @if (messageHeader) {
                  <h4 class="alert-heading" [innerHTML]="messageHeader"></h4>
                }
                @if (messageText) {
                  <!-- <p>{{messageText}}</p> -->
                  <p [innerHTML]="messageText"></p>
                }
                @if (isDismissibleShown) {
                  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                }

              </div>

              <div class="row">
                <div class="col-md-12 text-center">
                  @if (isFirstButttonShown) {
                    <button type="button" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onFirstButtonClick()">
                      {{firstButttonLabel}}
                    </button>
                  }
                  @if (isSecondButttonShown) {
                    <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onSecondButtonClick()">
                      {{secondButttonLabel}}
                    </button>
                  }
                </div>

              </div>

            </div>          
          </div>          

        </div>          


<!-- 
        </div>

      <div class="card-footer">

        <ng-template footerSection></ng-template>

      </div>

    </div>

  </div>

</div>
 -->
